import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AddTagValueInlineDialogData {
  tagId: number;
  tagName?: string;
  /** Texto tipeado en el lookup; se prellena y se puede editar */
  initialValue?: string;
}

export interface AddTagValueInlineDialogResult {
  value: string;
}

/**
 * PRICING-S03: confirmación de alta inline de un valor de etiqueta.
 * El POST lo hace el caller (GenericTagsSelectV2) tras cerrar con resultado.
 */
@Component({
  selector: 'add-tag-value-inline-modal',
  template: `
    <h2 mat-dialog-title>
      {{ 'ADMIN.MASTER.TAGS.ADD_TAG_VALUE_INLINE_TITLE' | pTranslate
      }}<ng-container *ngIf="data?.tagName"> — {{ data.tagName }}</ng-container>
    </h2>
    <mat-dialog-content>
      <mat-form-field fxFlex="100">
        <mat-label>{{ 'ADMIN.MASTER.TAGS.ADD_TAG_VALUE_INLINE_VALUE_LABEL' | pTranslate }}</mat-label>
        <input matInput [formControl]="valueCtrl" cdkFocusInitial [attr.data-test-id]="'add-tag-value-inline-input'" />
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()" [attr.data-test-id]="'add-tag-value-inline-cancel'">
        {{ 'ADMIN.MASTER.TAGS.CANCEL' | pTranslate }}
      </button>
      <button
        mat-raised-button
        color="accent"
        type="button"
        [disabled]="valueCtrl.invalid"
        (click)="confirm()"
        [attr.data-test-id]="'add-tag-value-inline-confirm'"
      >
        {{ 'ADMIN.MASTER.TAGS.ADD_TAG_VALUE_INLINE_CONFIRM' | pTranslate }}
      </button>
    </mat-dialog-actions>
  `,
})
export class AddTagValueInlineModalComponent {
  valueCtrl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(200)],
  });

  constructor(
    private dialogRef: MatDialogRef<AddTagValueInlineModalComponent, AddTagValueInlineDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: AddTagValueInlineDialogData
  ) {
    const initial = (data?.initialValue || '').trim();
    if (initial) this.valueCtrl.setValue(initial);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    const value = (this.valueCtrl.value || '').trim();
    if (!value) {
      this.valueCtrl.markAsTouched();
      return;
    }
    this.dialogRef.close({ value });
  }
}
